import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import { Link, withRouter } from 'react-router';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BorrowingStatus from '../../shared/BorrowingStatus';
import SidebarCompactTitle from '../../sidebar/SidebarCompactTitle';
import InterlibraryLoansSidebarLink from '../InterlibraryLoansSidebarLink';

const STATUS_ORDER = ['READY', 'IN_TRANSIT', 'SHIPPED', 'NOT_READY', 'INACTIVE'];

export class InterlibraryLoansStatus extends BcReactComponent {

  statusIsActive(status) {
    return this.props.router.location.pathname.includes(`v2/interlibraryloans/${status.toLowerCase()}`);
  }

  renderGrouping(status) {
    return (
      <InterlibraryLoansSidebarLink
        key={status}
        status={status}
        selected={this.statusIsActive(status)}
        summary={this.props.summary} />
    );
  }

  renderFullStatus() {
    const statusSummaries = this.props.summary.get('status', Immutable.Map());

    return (
      <span>
        <Link className="section-title" to="/v2/interlibraryloans">
          <FormattedMessage id="sidebar_title_ill" />
          <span className="pull-right" data-test-id="total-items-count">{this.props.summary.get('total')}</span>
        </Link>
        {statusSummaries
          .map((summary, status) => status)
          .toList()
          .sortBy(status => -1 * STATUS_ORDER.indexOf(status))
          .map(status => this.renderGrouping(status))
          .toArray()}
      </span>
    );
  }

  renderCompactStatus() {
    return (
      <SidebarCompactTitle
        title={<FormattedMessage id="sidebar_title_ill" />}
        count={this.props.summary.get('total')} />
    );
  }

  render() {
    return (
      <BorrowingStatus currentSection={this.props.currentSection} to="/v2/interlibraryloans">
        {this.props.currentSection ? this.renderFullStatus() : this.renderCompactStatus()}
      </BorrowingStatus>
    );
  }
}

InterlibraryLoansStatus.propTypes = {
  summary: ImmutablePropTypes.mapContains({
    total: PropTypes.number,
    status: ImmutablePropTypes.map
  })
};

export default withRouter(InterlibraryLoansStatus);



// WEBPACK FOOTER //
// ./app/components/borrowing/interlibraryLoans/InterlibraryLoansStatus/InterlibaryLoansStatus.jsx